/* __next_internal_client_entry_do_not_use__ FoundationIcon auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
// this icon wrapper is for Builder to render icon
export var FoundationIcon = function(param) {
    var iconName = param.iconName, fontSize = param.fontSize, color = param.color, direction = param.direction;
    var _React_useState = _sliced_to_array(React.useState(), 2), element = _React_useState[0], setElement = _React_useState[1];
    React.useEffect(function() {
        var lazyload = undefined;
        lazyload = import("@faire/web--source/slate/icons/__generated__/foundationIcons");
        if (lazyload) {
            lazyload.then(function(module) {
                var Icon = module[iconName];
                setElement(/*#__PURE__*/ _jsx(Icon, {
                    fontSize: "".concat(fontSize, "px"),
                    color: color,
                    direction: direction
                }));
            });
        }
    }, [
        color,
        direction,
        fontSize,
        iconName
    ]);
    return element;
};
